/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { traitStakingContract } from "config";
import { useContractWrite, useWaitForTransaction } from "wagmi";
import useSnackbarRpcError from "hooks/useSnackbarRpcError";
import useCaptureRpcException from "hooks/useCaptureRpcException";
import useSnackbarRpcSuccess from "hooks/useSnackbarRpcSuccess";

const useStakeTraits = (
  tokenId: number,
  traitsIds: number[],
  onSuccess?: () => void
): [() => void, boolean | undefined] => {
  const [{ data, loading: isLoading, error: writeError }, stake] =
    useContractWrite(
      {
        addressOrName: traitStakingContract.address,
        contractInterface: traitStakingContract.interface,
      },
      "stakeTraits",
      {
        args: [tokenId, traitsIds],
      }
    );

  const [{ data: waitData, loading: isWaiting, error: waitError }] =
    useWaitForTransaction({
      confirmations: 1,
      wait: data?.wait,
    });

  useSnackbarRpcError(writeError);
  useSnackbarRpcError(waitError);
  useSnackbarRpcSuccess(waitData);

  useCaptureRpcException(waitError);
  useCaptureRpcException(writeError);

  useEffect(() => {
    if (!isWaiting && waitData) {
      onSuccess?.();
    }
  }, [isWaiting, waitData]);

  return [stake, isLoading || isWaiting];
};

export default useStakeTraits;
